import { useQuery } from 'react-query'
import { GetLicensedLocations } from 'api/LicensedLocation'

export const UseLicensedLocationQuery = async () => {
  const queryKey = 'licensedLocations'
  const result = await useQuery(queryKey, () => GetLicensedLocations())
  return result
}
